<ng-template #labelContent>
  <div class="item-label" [class.clickable]="isClickableLabel()">
    @if (previewLayer() !== 'label' && !hidden && displayOptions.active && cosmeticOptions.highlight && cosmeticOptions.highlightColor && cosmeticOptions.beam) {
      <div class="beam"
        [class.beam-phase-in]="beamPhase === 'in'"
        [class.beam-phase-out]="beamPhase === 'out'"
        [class.beam-phase-idle-visible]="beamPhase === 'idle-visible'"
        [class.beam-phase-idle-hidden]="beamPhase === 'idle-hidden'"
        (animationend)="onBeamAnimationEnd($event)"
        [style.background-image]="'url(' + assetBaseUrl + '/img/beams/beam-' + cosmeticOptions.highlightColor.toLowerCase() + '.png)'"></div>
    }
    <div class="style-example"
      [class.glow]="showGlowAlways()"
      [class.glow-hover]="showGlowOnHover()"
      [class.glow-dimmed]="glowDimmed()"
      [style]="disabledLabelStyle ? itemStyleDisabled : itemStyle"
      (mouseenter)="onMouseEnter($event)"
      (mouseleave)="onMouseLeave($event)"
      (mousedown)="onLabelMouseDown($event)"
      (click)="clickLabel.emit($event)">
      @if (showGlowAlways() || showGlowOnHover()) {
        <div class="glow-noise" aria-hidden="true"></div>
      }
      @if (influence) {
        <img class="label-icon-prefix" src="{{ imgPrefix }}/img/icons/influences/{{ influence.toLowerCase() }}.png" [style]="disabledLabelStyle ? labelIconStyleDisabled : labelIconStyle">
      } @else if (memoryStrands) {
        <img class="label-icon-prefix" src="{{ imgPrefix }}/img/icons/memory-strand.png" [style]="disabledLabelStyle ? labelIconStyleDisabled : labelIconStyle">
      } @else if (fractured) {
        <img class="label-icon-prefix" src="{{ imgPrefix }}/img/icons/fractured.png" [style]="disabledLabelStyle ? labelIconStyleDisabled : labelIconStyle">
      } @else if (synthesised) {
        <img class="label-icon-prefix" src="{{ imgPrefix }}/img/icons/synthesised.png" [style]="disabledLabelStyle ? labelIconStyleDisabled : labelIconStyle">
      } @else if (veiled) {
        <img class="label-icon-prefix" src="{{ imgPrefix }}/img/icons/veiled.png" [style]="disabledLabelStyle ? labelIconStyleDisabled : labelIconStyle">
      }

      <div class="label-text">
        @if (rareName) {
          <div class="rare-name">{{ rareName }}</div>
        }

        @if (showJewelleryBaseTypeNav) {
          @if (stackSize() && stackSize()! > 1) { {{ stackSize() }}x }
          <span class="gear-tier-nav-link"
            [class.hovered]="jewelleryBaseTypeNavHovered()"
            (mouseenter)="onJewelleryBaseTypeMouseEnter()"
            (mouseleave)="onJewelleryBaseTypeMouseLeave()"
            (click)="onJewelleryBaseTypeClick($event)">{{ exampleName() }}</span>
        } @else if (showGearBaseTypeNav) {
          @if (stackSize() && stackSize()! > 1) { {{ stackSize() }}x }
          <span class="gear-tier-nav-link"
            [class.hovered]="gearBaseTypeNavHovered()"
            (mouseenter)="onGearBaseTypeMouseEnter()"
            (mouseleave)="onGearBaseTypeMouseLeave()"
            (click)="onGearBaseTypeClick($event)">{{ exampleName() }}</span>
        } @else {
          {{ displayName() }}
        }
        @if (unidentifiedItemTier) { (Tier {{ unidentifiedItemTier }}) }
      </div>

      <app-sockets-display [sockets]="sockets"></app-sockets-display>
    </div>
  </div>
</ng-template>

@if (disableBackground) {
  @if (!hidden || (!displayOptions.active && !forceHidden) || forceVisible) {
    <ng-container *ngTemplateOutlet="labelContent"></ng-container>
  }
} @else {
  <div class="example-bg-image" [style.background-image]="exampleBgImage()">
    <ng-container *ngTemplateOutlet="labelContent"></ng-container>
  </div>
}
